import { useState, useEffect } from 'react'

const EMAIL_TEMPLATES = {
  'flu-vaccination': {
    subject: 'Flu Vaccinations Now Available at Goosnargh Pharmacy',
    body: `Dear Patient,

We're pleased to announce that flu vaccinations are now available at Goosnargh Pharmacy.

The flu vaccine is recommended for:
- Adults aged 65 and over
- Those with certain health conditions
- Pregnant women
- Carers and healthcare workers

Book your appointment today by visiting our website or calling us.

Best regards,
Goosnargh Pharmacy
01772 865238`
  },
  'custom': {
    subject: '',
    body: ''
  }
}

function EmailComposerModal({ recipientCount, onClose, onSend, isSending, error }) {
  const [selectedTemplate, setSelectedTemplate] = useState('flu-vaccination')
  const [subject, setSubject] = useState(EMAIL_TEMPLATES['flu-vaccination'].subject)
  const [body, setBody] = useState(EMAIL_TEMPLATES['flu-vaccination'].body)

  useEffect(() => {
    const template = EMAIL_TEMPLATES[selectedTemplate]
    setSubject(template.subject)
    setBody(template.body)
  }, [selectedTemplate])

  const handleSubmit = (e) => {
    e.preventDefault()
    onSend(subject, body)
  }

  const isValid = subject.trim() && body.trim()

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Send Email to {recipientCount} Patient{recipientCount !== 1 ? 's' : ''}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          {error && (
            <div className="modal-error">
              <p>{error}</p>
            </div>
          )}

          <div className="form-group">
            <label htmlFor="template">Template</label>
            <select
              id="template"
              value={selectedTemplate}
              onChange={(e) => setSelectedTemplate(e.target.value)}
              disabled={isSending}
            >
              <option value="flu-vaccination">Flu Vaccination Available</option>
              <option value="custom">Custom</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="subject">Subject *</label>
            <input
              id="subject"
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
              disabled={isSending}
            />
          </div>

          <div className="form-group">
            <label htmlFor="body">Message *</label>
            <textarea
              id="body"
              value={body}
              onChange={(e) => setBody(e.target.value)}
              required
              disabled={isSending}
              rows={12}
            />
          </div>

          <div className="email-preview">
            <h4>Preview</h4>
            <div className="preview-box">
              <p className="preview-note">
                Email will be sent with Goosnargh Pharmacy branding header and footer.
              </p>
            </div>
          </div>

          <div className="modal-actions">
            <button
              type="button"
              className="button outline"
              onClick={onClose}
              disabled={isSending}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="button primary"
              disabled={isSending || !isValid}
            >
              {isSending ? 'Sending...' : `Send to ${recipientCount} Patient${recipientCount !== 1 ? 's' : ''}`}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default EmailComposerModal
